import { render, staticRenderFns } from "./BoardStoreItem.vue?vue&type=template&id=56513f5e&"
import script from "./BoardStoreItem.vue?vue&type=script&lang=js&"
export * from "./BoardStoreItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports